// extracted by mini-css-extract-plugin
module.exports = {"slat_header":"styles_slat_header__3dew2","tooltip":"styles_tooltip__2LK5E"};